module.exports = __webpack_public_path__ + "img/phrase.e6667efd.svg";